<template>
  <div class="m-label">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="member:config:label:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建标签</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #description="{ row }">{{ row.description }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <!-- <el-button type="text" @click="exportMemberByPortrait(scope.row)" >导出会员</el-button > -->
        <auth-button auth="member:config:label:update">
          <el-button type="text" class="mr10" @click="edit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button auth="member:config:label:delete">
          <el-button type="text" class="error" @click="deleteRow(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index"
import Table from "@/components/Table/index"
import Dialog from "@/components/Dialog/index"
import { api_getLabelPage, api_deleteLabel} from '@/api/member'
import tableList from '@/mixins/tableList'
export default {
  name: "mPortrait",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      renderData: [
        {
          label: "标签名称",
          placeholder: "请输入标签名称",
          type: "input",
          key: "name",
        }
      ],
      form: {
        name: "",
      },
      tableThData: [
        { prop: "name", label: "标签名称", minWidth: "120", },
        { prop: "description", label: "标签描述", minWidth: "260", },
        { prop: "created", label: "创建时间", minWidth: "130", },
        { prop: "operatorName", label: "操作人", minWidth: "130", },
        { prop: "operation", label: "操作", minWidth: "160", },
      ],
    };
  },
  created () {
  },
  methods: {
    onAdd () {
      this.$router.push({
        path: '/member/label/create'
      })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getLabelPage({name: this.form.name, limit: this.limit, offset: this.offset})
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 导出
    exportPortrait () {
    },
    // 编辑
    edit (row) {
      this.$router.push({
        path: '/member/label/create?id=' + row.id
      })
    },
    // 删除
    deleteRow (row) {
      this.$baseConfirm(
        '是否确认删除？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_deleteLabel({id: row.id})
          this.$baseMessage('删除成功', 'success')
          this.getList()
        }
      )
    },
    exportMemberByPortrait () {

    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.m-label {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .fun-btn-box {
    margin-top: 20px;
  }
  .level-update, .integral-update{
    margin-top: 22px;
    ::v-deep{
      .el-radio__label{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #05C8AF;
      }
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
        .tips{
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-left: 20px
        }
      }
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
}
</style>
